import clsx from 'clsx';
import { getImageProps } from 'next/image';
import { JSX, PropsWithChildren } from 'react';

type Tagname = 'div' | 'section' | 'article';

type Props<T extends Tagname> = {
  as?: T;
  containerClassName?: string;
  variant: 'default' | 'alternative' | 'gradient' | 'search' | 'seminar' | 'not-found';
} & JSX.IntrinsicElements[T];

function BackgroundContainer<T extends Tagname>(props: PropsWithChildren<Props<T>>) {
  const { children, className, variant, as: Element = 'div', containerClassName } = props;

  if (variant === 'gradient') {
    return (
      <Element className={clsx('background-container', 'background-container--gradient', className)}>
        <div className={clsx('container', containerClassName)}>{children}</div>
      </Element>
    );
  }

  if (variant === 'alternative') {
    const image = getImageProps({
      src: '/backgrounds/background-alternative.png',
      alt: '',
      width: 1440,
      height: 674,
    });

    return (
      <Element
        className={clsx('background-container', 'background-container--alternative', className)}
        style={{ backgroundImage: `url(${image.props.src})` }}
      >
        <div className={clsx('container', containerClassName)}>{children}</div>
      </Element>
    );
  }

  if (variant === 'seminar') {
    const image = getImageProps({
      src: '/backgrounds/background-seminars.png',
      alt: '',
      width: 1440,
      height: 674,
    });

    return (
      <Element
        className={clsx('background-container', 'background-container--image', className)}
        style={{ backgroundImage: `url(${image.props.src})` }}
      >
        <div className={clsx('container', containerClassName)}>{children}</div>
      </Element>
    );
  }

  if (variant === 'not-found') {
    const image = getImageProps({
      src: '/backgrounds/background-not-found.png',
      alt: '',
      width: 1440,
      height: 674,
    });

    return (
      <Element
        className={clsx('background-container', 'background-container--image', className)}
        style={{ backgroundImage: `url(${image.props.src})` }}
      >
        <div className={clsx('container', containerClassName)}>{children}</div>
      </Element>
    );
  }

  if (variant === 'search') {
    const image = getImageProps({
      src: '/backgrounds/background-search.png',
      alt: '',
      width: 1440,
      height: 674,
    });

    return (
      <Element
        className={clsx('background-container', 'background-container--image', className)}
        style={{ backgroundImage: `url(${image.props.src})` }}
      >
        <div className={clsx('container', containerClassName)}>{children}</div>
      </Element>
    );
  }

  const image = getImageProps({
    src: '/backgrounds/background.png',
    alt: '',
    width: 1440,
    height: 674,
  });

  return (
    <Element
      className={clsx('background-container', 'background-container--image', className)}
      style={{ backgroundImage: `url(${image.props.src})` }}
    >
      <div className={clsx('container', containerClassName)}>{children}</div>
    </Element>
  );
}

export default BackgroundContainer;
